import { Dropdown } from 'primereact/dropdown'
import React from 'react'
import "./style.css"

export const Select = ({ className, error, ...props }) => {
  return (
    <Dropdown {...props} clearIcon="pi pi-times" className={`select_maincon ${className} ${error ? "invalid_input_field" : ""} `} />
  )
}
